// src/redux/slice/orderSettingsSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "./api";

/**
 * ΦΕΡΝΟΥΜΕ ΤΙΣ ΡΥΘΜΙΣΕΙΣ ΑΠΟ BACKEND
 * GET /api/order-settings/get/
 */
export const fetchOrderSettings = createAsyncThunk(
  "orderSettings/fetchOrderSettings",
  async (_, { rejectWithValue }) => {
    try {
      const res = await api.get("/api/order-settings/get/");
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Αποτυχία φόρτωσης ρυθμίσεων."
      );
    }
  }
);

/**
 * ΑΠΟΘΗΚΕΥΣΗ ΡΥΘΜΙΣΕΩΝ
 * POST /api/order-settings/update/
 * payload:
 *  {
 *     percentages: { A, B },
 *     rules: [{ description_id, group }]
 *  }
 */
export const updateOrderSettings = createAsyncThunk(
  "orderSettings/updateOrderSettings",
  async (payload, { rejectWithValue }) => {
    try {
      const res = await api.post("/api/order-settings/update/", payload);
      return res.data;
    } catch (error) {
      return rejectWithValue(
        error?.response?.data?.message || "Αποτυχία αποθήκευσης ρυθμίσεων."
      );
    }
  }
);

const orderSettingsSlice = createSlice({
  name: "orderSettings",
  initialState: {
    percentages: { A: 0.6, B: 0.4 }, // fractions 0–1
    rules: [],                        // [{description_id, description_name, group}]
    status: "idle",
    error: null,
    saveStatus: "idle",
    saveError: null,
  },
  reducers: {
    resetOrderSettingsState: (state) => {
      state.percentages = { A: 0.6, B: 0.4 };
      state.rules = [];
      state.status = "idle";
      state.error = null;
      state.saveStatus = "idle";
      state.saveError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // FETCH
      .addCase(fetchOrderSettings.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(fetchOrderSettings.fulfilled, (state, action) => {
        state.status = "succeeded";
        const data = action.payload;

        if (data?.percentages) {
          state.percentages = data.percentages;
        }

        if (data?.rules) {
          state.rules = data.rules;
        }
      })
      .addCase(fetchOrderSettings.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      })

      // UPDATE
      .addCase(updateOrderSettings.pending, (state) => {
        state.saveStatus = "loading";
        state.saveError = null;
      })
      .addCase(updateOrderSettings.fulfilled, (state) => {
        state.saveStatus = "succeeded";
      })
      .addCase(updateOrderSettings.rejected, (state, action) => {
        state.saveStatus = "failed";
        state.saveError = action.payload;
      });
  },
});

export const { resetOrderSettingsState } = orderSettingsSlice.actions;
export default orderSettingsSlice.reducer;
